import {keyBy, sum, map} from 'lodash/fp'

const LULUCF = 0.90766
const emission = (id, name, capitaCo2) => ({id, name, co2: capitaCo2 * LULUCF})

export const emissions = keyBy('id', [
  emission('snackFoods', 'Snack Foods (incl. Palm Oil)', 0.1249630189),
  emission('cropsAndVegetables', 'Crops & Veg Food Production', 1.009376694),
  emission('beefAndLamb', 'Beef & Lamb', 0.885),
  emission('pork', 'Pork', 0.1248290515),
  emission('chickenAndTurkey', 'Chicken & Turkey', 0.160699468571177),
  emission('dairyAndEggs', 'Dairy & Eggs', 0.0633),
  emission('seafood', 'Seafood', 0.03013115036),
  emission('solidWaste', 'Solid Waste w/ Freight', 0.3084528302),
  emission('wastewaterTreatment', 'Wastewater Treatment', 0.03679245283),
  emission('powerForWaterSupply', 'Power-for-Water Supply', 0.0279245283),
  emission('spaceHeating', 'Space Heating', 1.178113208),
  emission('waterHeating', 'Water Heating', 0.500754717),
  emission('otherHeating', 'Other Heating', 0.1419625166),
  emission('cooling', 'Cooling', 0.2964241509),
  emission('mainRefrigerator', 'Main Refrigerator', 0.1271973498),
  emission('extraFridge', 'Extra Fridge/Freezer', 0.06729401072),
  emission('lighting', 'Lighting', 0.2607952334),
  emission('tv', 'TV (and related)', 0.1458685204),
  emission('otherElectrical', 'Other Electrical', 0.772),
  emission('primaryHomes', 'Construction (primary homes)', 0.1529230189),
  emission('secondaryHomes', 'Construction (secondary homes)', 0.1261335849),
  emission('manufacturedGoods', 'Manufactured Goods', 0.422),
  emission('vehicleManufacturing', 'Vehicle Manufacturing', 0.1857817358),
  emission('transportation', 'Transportation', 3.175),
  emission('hotelEnergy', 'Hotel Electricity & Heating', 0.1858490566),
  emission('boatTravel', 'Boat Travel w/ Fuel Production', 0.06264150943),
  emission('airCommuter', 'Air Travel w/ Fuel & Forcing - Commuter', 0.098),
  emission('airShort', 'Air Travel w/ Fuel & Forcing - Short', 0.1355494587),
  emission('airMedium', 'Air Travel w/ Fuel & Forcing - Medium', 0.1355494587),
  emission('airLong', 'Air Travel w/ Fuel & Forcing - Long', 0.05008988322),
  emission('airExtraLong', 'Air Travel w/ Fuel & Forcing - Extra Long', 0.00556554258),
])

export const avgCo2 = sum(map('co2', emissions))

export const categoryMeta = keyBy('id')([
  {
    id: 'food',
    display: 'Food & Beverages',
  },
  {
    id: 'waterAndWaste',
    display: 'Water & Waste',
  },
  {
    id: 'heating',
    display: 'Heating',
  },
  {
    id: 'electricity',
    display: 'Electricity',
  },
  {
    id: 'goods',
    display: 'Consumer Goods',
  },
  {
    id: 'transportation',
    display: 'Transportation',
  },
  {
    id: 'travel',
    display: 'Travel',
  },
])

export const categories = {
  food: [
    'snackFoods',
    'cropsAndVegetables',
    'beefAndLamb',
    'pork',
    'chickenAndTurkey',
    'dairyAndEggs',
    'seafood',
  ],
  waterAndWaste: [
    'solidWaste',
    'wastewaterTreatment',
    'powerForWaterSupply',
  ],
  heating: [
    'spaceHeating',
    'waterHeating',
    'otherHeating',
  ],
  electricity: [
    'cooling',
    'mainRefrigerator',
    'extraFridge',
    'lighting',
    'tv',
    'otherElectrical',
  ],
  goods: [
    'primaryHomes',
    'secondaryHomes',
    'manufacturedGoods',
    'vehicleManufacturing',
  ],
  transportation: [
    'transportation',
  ],
  travel: [
    'hotelEnergy',
    'boatTravel',
    'airCommuter',
    'airShort',
    'airMedium',
    'airLong',
    'airExtraLong',
  ],
}



// WEBPACK FOOTER //
// ./src/data/categories.js